<template>
  <DpplInfoTooltip
    :tooltip="tooltip"
    :tooltip-placement="tooltipPlacement"
    :tooltip-offset="tooltipOffset"
    :multiple-tooltip-offsets="multipleTooltipOffsets"
    :max-width="maxWidth"
    :teleport="teleport"
  />
</template>

<script setup>
import DpplInfoTooltip from '@/components/datapeople/DpplInfoTooltip.vue';

defineProps({
  tooltip: {
    type: Object,
    default: () => ({}),
  },
  tooltipPlacement: {
    type: String,
    default: 'right',
  },
  maxWidth: {
    type: String,
    default: '252px',
  },
  tooltipOffset: {
    type: Number,
    default: 12,
  },
  multipleTooltipOffsets: {
    type: Object,
    default: () => ({}),
  },
  // On by default so tooltips don't get cut off in filter drawers
  teleport: {
    type: Boolean,
    default: true,
  },
});
</script>
